import { render, staticRenderFns } from "./QuestionSection.vue?vue&type=template&id=31fd38bd&scoped=true"
import script from "./QuestionSection.vue?vue&type=script&lang=js"
export * from "./QuestionSection.vue?vue&type=script&lang=js"
import style0 from "./QuestionSection.vue?vue&type=style&index=0&id=31fd38bd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fd38bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31fd38bd')) {
      api.createRecord('31fd38bd', component.options)
    } else {
      api.reload('31fd38bd', component.options)
    }
    module.hot.accept("./QuestionSection.vue?vue&type=template&id=31fd38bd&scoped=true", function () {
      api.rerender('31fd38bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Shared/UIComponents/QuestionSection.vue"
export default component.exports